import { getDataSourceSrv } from '@grafana/runtime';

async function getDataSource(datasource, scopedVars) {
  if (datasource && datasource.query) {
    return datasource;
  }
  return await getDataSourceSrv().get(datasource, scopedVars);
}

export { getDataSource };
//# sourceMappingURL=getDataSource.js.map
